<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2> निपटान विभाजन   </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="1">
                <div
                    style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                    <iframe class="i-frame" src="https://www.youtube.com/embed/5kY7ApMM9Uo"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>    -->
                <div class="col-md-12" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')" id="2">
                    <label for="" class="mt-3">पे जी स्प्लिट सेटलमेंट एक ऐसी सुविधा है जिसे आपके भागीदारों और आपूर्तिकर्ताओं को आसानी से भुगतान करने की प्रक्रिया को सरल बनाने के लिए डिज़ाइन किया गया है।  </label>
                </div>


                <div class="col-md-12" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')" id="3">
                    <h2 class="mt-5">पे जी स्प्लिट सेटलमेंट के मुख्य लाभ: </h2>

                    <label for="" class="mt-3"><b>सहज स्थानांतरण: &nbsp;</b> अपने व्यवसाय को बढ़ाने पर ध्यान केंद्रित रखें जबकि पे जी आपके भागीदारों और आपूर्तिकर्ताओं को राशि का निर्बाध रूप से निपटान करने का ध्यान रखता है। </label>
                    <label for="" class="mt-3"><b>समय बचाने वाला समाधान: &nbsp;</b> एकाधिक स्थानांतरण प्रबंधित करने की मैन्युअल परेशानी को अलविदा कहें। पे जी स्प्लिट सेटलमेंट प्रक्रिया को स्वचालित करता है, जिससे आपका बहुमूल्य समय बचता है। </label>
                    <label for="" class="mt-3"><b>कम जटिलता: &nbsp;</b> निपटान प्रक्रियाओं को समेकित करके अपने वित्तीय कार्यप्रवाह को सुव्यवस्थित करें। भुगतान प्रबंधित करने के लिए एक स्पष्ट, अधिक व्यवस्थित दृष्टिकोण का आनंद लें। </label>
                    <label for="" class="mt-3"><b>सुरक्षित लेनदेन: &nbsp;</b>यह जानकर निश्चिंत रहें कि पे जी वित्तीय लेनदेन के लिए उच्चतम उद्योग मानकों का पालन करते हुए सुरक्षित और विश्वसनीय हस्तांतरण सुनिश्चित करता है। </label>
                </div>

                <div class="col-md-12" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')" id="4">
                    <h2 class="mt-5">पे जी स्प्लिट सेटलमेंट कैसे काम करता है: </h2>

                    <label for="" class="mt-3"><b> स्वचालित गणना:&nbsp;</b>पे जी सटीकता और दक्षता सुनिश्चित करते हुए, आपके पूर्वनिर्धारित मापदंडों के आधार पर निपटान राशि की बुद्धिमानी से गणना और विभाजन करता है। </label>
                    <label for="" class="mt-3"><b> निर्बाध एकीकरण: &nbsp;</b> पे जी स्प्लिट सेटलमेंट को अपने मौजूदा सिस्टम में सहजता से एकीकृत करें। जटिल सेटअप या व्यापक तकनीकी जानकारी की कोई आवश्यकता नहीं है। </label>
                    <label for="" class="mt-3"><b>रीयल-टाइम ट्रैकिंग: &nbsp;</b>अपनी निपटान प्रक्रियाओं में रीयल-टाइम दृश्यता प्राप्त करें। पे जी डैशबोर्ड के माध्यम से लेनदेन को आसानी से ट्रैक और मॉनिटर करें। </label>
                    <label for="" class="mt-3"><b>अनुकूलन योग्य सेटिंग्स:  &nbsp;</b>अपनी विशिष्ट व्यावसायिक आवश्यकताओं के अनुसार निपटान मापदंडों को तैयार करें। पे जी विभिन्न साझेदारी और आपूर्तिकर्ता व्यवस्थाओं को समायोजित करने के लिए लचीलापन प्रदान करता है। </label>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')" id="5">
                    <h2 class="mt-5">

                        पे जी स्प्लिट सेटलमेंट को कैसे सक्रिय करें: 
                    </h2>

                    <label for="" class="mt-3"><b>खाता सक्रियण: &nbsp;</b>  एक निर्बाध प्रक्रिया के माध्यम से पे जी स्प्लिट सेटलमेंट को सक्रिय करें। अपने खाते के लिए इस सुविधा को सक्षम करने के लिए हमारी सहायता टीम से संपर्क करें। </label>

                    <label for="" class="mt-3"><b>राशि या प्रतिशत का चयन करें: &nbsp;</b> राशि को एक निश्चित राशि या प्रतिशत के आधार पर विभाजित करने का चयन करके अपनी निपटान प्राथमिकताओं को अनुकूलित करें। पे जी आपको लचीलेपन के साथ सशक्त बनाता है। </label>

                    <label for="" class="mt-3"><b>विवरण डालें:&nbsp;</b> प्राप्तकर्ता का नाम, खाता संख्या, भुगतान का उद्देश्य और बहुत कुछ सहित आवश्यक विवरण भरें। यह आपके भागीदारों या आपूर्तिकर्ताओं के साथ पारदर्शी संचार सुनिश्चित करता है। </label>

                    <label for="" class="mt-3"><b>सूचना प्राप्त करें:  &nbsp;</b>एक बार निपटान पूरा हो जाने पर, पे जी स्वचालित रूप से निर्दिष्ट राशि को दिए गए खाता नंबरों में स्थानांतरित कर देता है। इसके साथ ही, आपको त्वरित सूचनाएं प्राप्त होती हैं, जिससे आपको सफल लेनदेन के बारे में जानकारी मिलती रहती है। </label>

                    <label for="" class="mt-3"><b>सहज वर्कफ़्लो: &nbsp;</b> एक सुव्यवस्थित वित्तीय वर्कफ़्लो का आनंद लें क्योंकि पे जी भुगतान निपटाने की जटिलताओं को सरल बनाता है। हम लेन-देन की परेशानी से निपटने के साथ-साथ अपने व्यवसाय को बढ़ाने पर ध्यान दें। </label>

                    <label for="" class="mt-3"><b>अनुकूलन विकल्प:&nbsp;</b> अपनी विशिष्ट व्यावसायिक आवश्यकताओं के अनुरूप निपटान मापदंडों को अनुकूलित करें। चाहे आप एक निश्चित राशि या प्रतिशत-आधारित विभाजन पसंद करते हों, पे जी आपकी प्राथमिकताओं को सहजता से अपनाता है। </label>

                    <label for="" class="mt-3"><b> वास्तविक समय ट्रैकिंग:  &nbsp;</b> पे जी डैशबोर्ड के माध्यम से वास्तविक समय में पूरी प्रक्रिया की निगरानी करें। निपटानों पर नज़र रखें, लेन-देन विवरण देखें, और अपने वित्तीय संचालन पर नियंत्रण रखें। </label>

                    <label for="" class="mt-3"><b>सरलीकृत भुगतान:  &nbsp;</b> मैन्युअल प्रयासों और समय लेने वाली भुगतान प्रक्रियाओं को अलविदा कहें। पे जी स्प्लिट सेटलमेंट आपके भुगतान को संभालने के तरीके को बदल देता है, जिससे यह एक परेशानी मुक्त अनुभव बन जाता है। </label>

                    <label for="" class="mt-3"><b>उन्नत संचार: &nbsp;</b> प्रक्रिया के दौरान आपके द्वारा दर्ज किए गए विवरण प्राप्तकर्ताओं के साथ साझा किए जाते हैं, जिससे पार्टियों के बीच पारदर्शिता और कुशल संचार को बढ़ावा मिलता है। 

                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची  
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')"> निपटान विभाजन  </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')"> निपटान विभाजन के लाभ   </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')"> यह काम किस प्रकार करता है?   </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">   इसे कैसे सक्रिय करें?  </span>

                            </div>
                        </div>
                    </a>
                </div>      
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/price']"> <button class="btn btn-color" > <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;मूल्य 
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/report']"> <button class="btn btn-color"
                        (click)="menues('Reports')">रिपोर्टस 
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div> 
        </div>
    </div>
</div>